<template>
    <form class="modal" @submit.prevent="createStation">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Crear nueva estación</h5>
                    <button @click="closeModal" type="button" class="btn-close" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="stationCode" class="form-label">Código de estación</label>
                        <input v-model="newStation.code" type="text" class="form-control" id="stationCode" required>
                    </div>
                    <div class="mb-3">
                        <label for="stationDescrip" class="form-label">Descripción de estación</label>
                        <input v-model="newStation.descrip" type="text" class="form-control" id="stationDescrip" required>
                    </div>
                    <div style="display: flex;">
                        <label for="stationLineLimiter" class="form-label" style="margin-right: 3ch;">Limita la línea de producción</label>
                        <label class="form-check form-switch">
                            <input type="checkbox" v-model="newStation.line_limiter" class="form-check-input">
                        </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="closeModal" type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancelar</button>
                    <button type="submit" class="btn btn-success">Guardar</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
    name: "StationCreateModal",
    props:{
        productionLineId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            newStation: {
                code: '',
                descrip: '',
                line_limiter: false,
            },
        };
    },
    methods: {
        createStation() {
            let data = {
                code: this.newStation.code,
                descrip: this.newStation.descrip,
                production_line_id: this.productionLineId,
                line_limiter: this.newStation.line_limiter,
                order: 0,
            };
            axios.post('/api/station', data)
                .then(() => {
                    showCustomSuccessSweetAlert('Estación creada correctamente');
                    this.$emit('station-created');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        closeModal() {
            this.$emit('close-modal');
        },
    },
};
</script>
